import { container } from './container';
import { RemoteWidgetHandlerClassSymbol } from './symbols';
/**
 * Создает экземпляр обработчика ремоут компонентов
 * @param headers
 * @param serviceDiscoveryClient
 * @param mfServer
 * @param transaction
 */
export const remoteHandlerFactory = (headers, serviceDiscoveryClient, mfServer, transaction) => {
    const HandlerClass = container.get(RemoteWidgetHandlerClassSymbol);
    return new HandlerClass(serviceDiscoveryClient, headers, mfServer, transaction);
};
